var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.isShowCardFrame))?_c('div',{staticClass:"coupon-card-container"},[_c('card-frame',{class:(_vm.cardFrameClass),attrs:{"cardConf":(_vm.couponCardConf)}},[_c('coupon-item',{staticClass:"coupon-item",attrs:{"couponData":(_vm.couponData)}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }